import loadJS from '../../lib-js/dom/network/load-js';

const URL_DW_UTILS = 'https://resc.deskline.net/DW5/dw-utility.js';

let loadedPromise = null;

export function withDwUtils(cb) {
	const placeholderDw = function (...args) {
		(window.dw.q = window.dw.q || []).push(args);
	};

	window.dw = window.dw || placeholderDw;
	window.dwUtilityConf = window.dwUtilityConf || {};
	placeholderDw.q = placeholderDw.q || [];

	if (loadedPromise === null) {
		loadedPromise = new Promise((resolve, reject) => {
			loadJS(URL_DW_UTILS, () => {
				if (!window.dw.accommodationQuickFind) {
					console.error('tosc5 utils not loaded');
					reject();
				} else {
					console.info('dw utils loaded');
					setTimeout(() => {
						resolve();
					}, 500);
				}
			});
		});
	}

	if (cb) {
		loadedPromise.then(cb);
	}
}
